import {
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect } from "react";
import useUSerSetting from "../../../utils/useUSerSetting";
import useDeviceType from "../../global/Hooks/useDeviceType";
import { useDashboardSettings } from "../../../Context/DashboardSettingProvider";

function ControllerDashChart() {
  const theme = useTheme().palette.mode;
  const { dashControlleChart, update } = useDashboardSettings();
  const deviceType = useDeviceType();
  const changehandler = (key) => {
    const item = dashControlleChart.find((i) => i.chart === key);

    if (item) {
      update({ ...item, value: !item.value });
    }
  };
  return (
    <Box
      sx={{
        background:
          theme === "dark" && deviceType != "mobile"
            ? "#262D39"
            : deviceType != "mobile"
            ? "#FFF"
            : "unset",
        boxShadow:
          deviceType != "mobile"
            ? "0px 1px 2px 0px rgba(0, 0, 0, 0.14)"
            : "unset",
        padding: "1rem",
        borderRadius: "1rem",
        margin: "1rem 0",
      }}
    >
      <div>
        <Typography> لیست چارت ها </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
          {dashControlleChart?.map((item) => {
            return (
              <CheckBoxItem
                key={item.chart}
                chart={item.chart}
                label={item.label}
                checked={item.value}
                changehandler={changehandler}
              />
            );
          })}
        </Box>
      </div>
    </Box>
  );
}

export default ControllerDashChart;

const CheckBoxItem = ({ checked, label, changehandler, chart }) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          sx={{
            "&.Mui-checked": {
              color: "#1E6AFD !important", // تغییر رنگ چک باکس زمانی که فعال شده است
              paddingBottom: "1rem",
            },
          }}
        />
      }
      label={label}
      onClick={() => changehandler(chart)}
    />
  );
};
